export const types = {
    platform_etiquette: {
        "key": "platform_etiquette",
        "slug": "platform-etiquette",
        "type": "Platform Etiquette"
    },
    registration: {
        "key": "registration",
        "slug": "registration",
        "type": "Registration"
    },
    gig_lister: {
        "key": "gig_lister",
        "slug": "gig-lister",
        "type": "Gig Lister"
    },
    gig_worker: {
        "key": "gig_worker",
        "slug": "gig-worker",
        "type": "Gig Worker"
    },
    job_lister: {
        "key": "job_lister",
        "slug": "job-lister",
        "type": "Job Lister"
    },
    job_hunter: {
        "key": "job_hunter",
        "slug": "job-hunter",
        "type": "Job Hunter"
    },
    recruiter: {
        "key": "recruiter",
        "slug": "recruiter",
        "type": "Recruiter"
    },
    promote: {
        "key": "promote",
        "slug": "promote",
        "type": "Promote"
    },
    volunteer: {
        "key": "volunteer",
        "slug": "volunteer",
        "type": "Volunteer"
    },
    volunteer_request: {
        "key": "volunteer_request",
        "slug": "volunteer-request",
        "type": "Volunteer Request"
    },
    technology: {
        "key": "technology",
        "slug": "technology",
        "type": "Technology"
    },
    money: {
        "key": "money",
        "slug": "money",
        "type": "Money"
    }
}